const roles = [
  {
    role: "Material Handlers",
    description:
      "They pick and fill orders, scan cabinets and customer locations, label product",
    className: "",
    id: 1,
  },
  {
    role: "Chemical Coordinators",
    description:
      "Chemical Coordinators receive inventory, add QC documents, print labels, process orders, ship material",
    className: "",
    id: 2,
  },
  {
    role: "Material Coordinators",
    description:
      "Material coordinators review usage and supply chain reports in HMM (then order replenishment inventory in the ERP)",
    className: "",
    id: 3,
  },
  {
    role: "Inventory Control Data Coordinator",
    description:
      "This coordinator runs billing/invoicing, inventory cycle counts, inventory compare between HMM & ERP",
    className: "",
    id: 4,
  },
  {
    role: "Chemical Manager / supervisor",
    description:
      "The chemical manager or supervisor runs reports, manage customer relationship, lead the handler/coordinator teams, maintain min/max & bin data.",
    className: "",
    id: 5,
  },
  {
    role: "Implementation Supervisors",
    description: "They manage set up of new customers",
    className: "",
    id: 6,
  },
  {
    role: "EHS Coordinators",
    description:
      "These coordinators maintain SDS (safety data sheets) files and chemical data",
    className: "",
    id: 7,
  },
  {
    role: "Global admins",
    description:
      "Admins view SDS, order demand items, run environmental reports, view usage and inventory reports and data",
    className: "",
    id: 8,
  },
];

export default roles;
